import {load} from '@shopify/theme-sections'

import '../sections/section-custom-collection-list'
import '../sections/section-heading-text'
import '../sections/section-six-tiles'
import '../sections/section-2-price-card'
import '../sections/custom-images'
import '../sections/index-image-content'
import '../sections/tabs-content'
import '../sections/section-three-card-blogs'
import '../sections/section-accordion-two-columns-v2'
import '../sections/section-enquire-form-v2'
import '../sections/section-steps'
import '../sections/section-4-col-tiles'
import '../sections/section-collection-grid-info'
import '../sections/section-center-text'

load(
    [
        `section-custom-collection-list`,
        `section-heading-text`,
        `section-six-tiles`,
        `section-2-price-card`,
        `custom-images`,
        `index-image-content`,
        `tabs-content`,
        `section-three-card-blogs`,
        `section-accordion-two-columns-v2`,
        `section-enquire-form-v2`,
        `section-steps`,
        `section-4-col-tiles`,
        `section-collection-grid-info`
    ]
)
